// extracted by mini-css-extract-plugin
export default {"Img":"StatusNotOk_Img__xMhEy"};